import styled from 'styled-components/macro';

import { baseSpacing } from 'css/constants';

export const InstanceOption = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const OptionInfo = styled.span`
  font-style: italic;
`;

export const RadiosWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledDatePicker = styled.div`
  flex-grow: 1;
  align-items: center;
  margin-left: ${baseSpacing / 2}px;
`;

export const CreditSummaryMessage = styled.div`
  margin: 0;

  p {
    margin-bottom: 0;
  }

  span {
    display: block;
  }
`;
